import React from "react";
import { makeStyles, useTheme } from "@mui/styles";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
} from "@mui/material";
import { height } from "@mui/system";
import { Formik } from "formik";
import surveyIllustration from "../assets/survey-illustration.jpg";
import wallpaper from "../assets/wallpaper.jpg";
import illustration from "../assets/survey-illustration.png";
import SurveyForm from "./SurveyForm";
import SurveyForm2 from "./SurveyForm-test";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    background: "#263859",
    // backgroundImage: `url(${wallpaper})`,
    backgroundSize: "cover",

    minHeight: "100vh",
  },
  text: {
    color: "red",
  },
  paragraph: {
    fontSize: "1.2rem",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.5rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "2rem",
    },
  },
  illu: {
    position: "fixed",
    height: "20vh",
    bottom: 0,
    right: 0,
    animation: "$move 3s ", // add animation
  },
  "@keyframes move": {
    "0%": {
      right: "100%", // start from the right
    },
    "100%": {
      right: 0, // move towards 0
    },
  },
}));

const Body = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = theme.breakpoints.down("sm");

  return (
    <div className={classes.root}>
      <div className={classes.illustration}>
        <img src={illustration} className={classes.illu} />
      </div>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography
                  variant="h3"
                  component="h1"
                  align="center"
                  className={classes.text}
                  style={{ fontSize: isMobile ? "1.8rem" : "15rem" }}
                >
                  Welcome to Foshizi!
                </Typography>
                <Typography
                  variant="body1"
                  marginTop={3}
                  className={classes.paragraph}
                  style={{ fontWeight: isMobile ? "2rem" : "15rem" }}
                >
                  My name is John Doe and I work for Foshizi, an independent
                  market research agency. We are currently conducting a research
                  aimed at understanding consumer shopping behaviour for
                  different products which include cabinet material and beds.
                  This research will further explore your views with regards to
                  litter and recycling.
                </Typography>
              </CardContent>
            </Card>
            <Box height={20} />
            <Card>
              <CardContent></CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Body;
